"use strict";
require('./CompanyInvestigationListService.js');

CompanyInvestigationListCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  'investigationList'
];

function CompanyInvestigationListCtrl(
  $scope,
  $stateParams,
  $state,
  investigationList
) {
  $scope.investigationList = investigationList;
  $scope.more = false;
  $scope.page = $stateParams.page|0;
  if($scope.investigationList.length >= 20) {
    $scope.more = true;
  }

  $scope.paramStatus = $stateParams.status || "OPEN";
  $scope.checkOpenInvestigation = ($scope.paramStatus === 'OPEN' ? true : false);
  $scope.filterName = $stateParams.qInves;
  $scope.filterStep = $stateParams.step ? parseInt($stateParams.step) : "";

  $scope.searchInvestigationList = function() {
    $state.go('.', {
      status: ($scope.checkOpenInvestigation ? 'OPEN' : 'DONE'),
      qInves: $scope.filterName,
      step: $scope.filterStep
    });
  };
}

CompanyInvestigationListCtrl.resolve = {
  investigationList: ['$stateParams', 'CompanyInvestigationListService', function($stateParams, CompanyInvestigationListService) {
    return CompanyInvestigationListService.query({
      companyId: $stateParams.companyId,
      offset: ($stateParams.page|0) * 20,
      limit:  21,
      status: $stateParams.status || "OPEN",
      step: $stateParams.step,
      q: $stateParams.qInves
      }).$promise;
  }]
};

module.exports  = CompanyInvestigationListCtrl;

angular.module("dokiv")
  .controller("CompanyInvestigationListCtrl", CompanyInvestigationListCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/investigation-list/CompanyInvestigationListCtrl.js
// module id = 360
// module chunks = 0